import {AlunoPremiado} from "@/models/AlunoPremiado";

export default {
    nivel1: {
        ouro: [
            new AlunoPremiado('Davi Lobo Fernandes', 'A'),
            new AlunoPremiado('Paulo Henrique Pinheiro Tavares', 'A'),
            new AlunoPremiado('Rafael Martins Farias Maia', 'A')
        ],
        prata: [
            new AlunoPremiado('Artur Rebouças de Alencar Araripe', 'A', 2),
            new AlunoPremiado('Gabriel de Castro Loiola'),
            new AlunoPremiado('Lucas dos Santos Mauricio Maia'),
            new AlunoPremiado('Pedro Guilherme Lima de Sousa', 'A', 1),
            new AlunoPremiado('Pedro Moisés Nobre Fonsêca')
        ],
        bronze: [
            new AlunoPremiado('Bruno Pordeus Barroso Jales'),
            new AlunoPremiado('Daniel Leite Mendes'),
            new AlunoPremiado('Daniel Vale Locio'),
            new AlunoPremiado('Letícia Dias Damasceno'),
            new AlunoPremiado('Levi Queiroz Cavalcante'),
            new AlunoPremiado('Miguel Cavalcante Rocha')
        ],
        mencaoHonrosa: [
            new AlunoPremiado('Allan Oliveira do Carmo'),
            new AlunoPremiado('Ana Elise de Araújo Bezerra'),
            new AlunoPremiado('Bernardo Cavalcante Diogenes'),
            new AlunoPremiado('Clarisse Damasceno Braga'),
            new AlunoPremiado('Dafne Porto Rodrigues'),
            new AlunoPremiado('Davi Guimarães Tavares Napoleão de Araújo'),
            new AlunoPremiado('Francisco Abner Gomes da Silva'),
            new AlunoPremiado('Mateus Barboza Borges'),
            new AlunoPremiado('Miguel Jesus Francisco Nogueira'),
            new AlunoPremiado('Pablo Pinto Benevides Filho')
        ]
    },
    nivel2: {
        ouro: [
            new AlunoPremiado('Julia de Paula Pessoa Leguiza', 1),
            new AlunoPremiado('Luiz Efraim Cavalcante Basilio', 1),
            new AlunoPremiado('Samuel Nogueira Santiago', 1)
        ],
        prata: [
            new AlunoPremiado('Arthur Alencar Spuri', 1, 2),
            new AlunoPremiado('Davi Lima Maia'),
            new AlunoPremiado('Jose Elias Padovan Britto'),
            new AlunoPremiado('Mateus Nogueira Cavalcanti Cajado', 1, 1)
        ],
        bronze: [
            new AlunoPremiado('Davi de Sa Ecard'),
            new AlunoPremiado('Gabriel Amorim Santiago'),
            new AlunoPremiado('Gabriel Mota Caminha Muniz'),
            new AlunoPremiado('Josué Busetti'),
            new AlunoPremiado('Rafael Cruz Lopes'),
            new AlunoPremiado('Renan Andrade de Menezes'),
            new AlunoPremiado('Valter da Silva Novais Neto')
        ],
        mencaoHonrosa: [
            new AlunoPremiado('Caio Facó Fonseca Bittencourt'),
            new AlunoPremiado('Felipe Pessoa de Andrade Dantas'),
            new AlunoPremiado('Giselly Ingrid Teixeira de Oliveira'),
            new AlunoPremiado('Gustavo Penedo de Albuquerque Cabral Filho'),
            new AlunoPremiado('Jose Ricardo de Moraes Costa Neto'),
            new AlunoPremiado('João Victor Veras Chaves'),
            new AlunoPremiado('Luana Morais Barros'),
            new AlunoPremiado('Maria Clara Carneiro Duarte'),
            new AlunoPremiado('Maria Eduarda Linhares Aguiar'),
            new AlunoPremiado('Samuel Caleb Nunes Camara')
        ]
    },
    nivel3: {
        ouro: [
            new AlunoPremiado('Caique Paiva', 3),
            new AlunoPremiado('Levi Magalhaes Pereira Castello Branco', 2),
            new AlunoPremiado('Matheus Alencar de Moraes', 3)
        ],
        prata: [
            new AlunoPremiado('Alessandro Mathias Machado', 2),
            new AlunoPremiado('Enzo Holanda Sampaio', 2),
            new AlunoPremiado('Pedro Duarte Borges', 3),
            new AlunoPremiado('Rodrigo Fontenele de Oliveira Linhares', 3, 1)
        ],
        bronze: [
            new AlunoPremiado('Gustavo Mesquita Franca', 3, 2),
            new AlunoPremiado('Joao Victor Silva dos Santos'),
            new AlunoPremiado('Levi Felix Barbosa'),
            new AlunoPremiado('Matheus Soares Fondello'),
            new AlunoPremiado('Miguel Chianca Evangelista'),
            new AlunoPremiado('Paulo Jonatas de Oliveira Pimentel Leite', 2, 1),
            new AlunoPremiado('Paulo Vinicius Rodrigues de Azevedo', 2, 2),
            new AlunoPremiado('Pedro Vitor Lutke')
        ],
        mencaoHonrosa: [
            new AlunoPremiado('Adryan Freitas Batista de Oliveira'),
            new AlunoPremiado('Alice Ella Schneider'),
            new AlunoPremiado('Elias do Nascimento Barros'),
            new AlunoPremiado('Iago de Brito Vieira'),
            new AlunoPremiado('Joao Pedro de Almeida da Silva'),
            new AlunoPremiado('Miguel Espindola Papa'),
            new AlunoPremiado('Paulo Sergio Bezerra Freitas Gouveia'),
            new AlunoPremiado('Thiago Hiroshi Hara Ida')
        ]
    }
}